import { Pipe, PipeTransform } from '@angular/core';
import { isBoolean, isString, isUndefined } from 'lodash';
import {
  extractDeepPropertyByMapKey,
  extractDeepPropertyByParentMapKey,
  isNumberFinite,
} from '@iris/common/modules/pipes-common/helpers/helpers';

@Pipe({
  name: 'filterBy',
  standalone: true,
})
export class FilterByPipe implements PipeTransform {
  transform<T>(input: T, props: Array<string>, search?: unknown, strict?: boolean): T;
  transform(input: unknown[], props: Array<string>, search?: unknown, strict?: boolean): unknown[];
  transform(input: unknown, props: Array<string>, search: unknown = '', strict: boolean = false): unknown {
    if (
      !Array.isArray(input) ||
      (!Array.isArray(search) && !isString(search) && !isNumberFinite(search) && !isBoolean(search))
    ) {
      return input;
    }

    const terms = String(search).toLowerCase().split(',');

    return input.filter(obj => {
      return props.some(prop => {
        return terms.some(term => {
          const value = extractDeepPropertyByMapKey(obj, prop);
          const { props, tail } = extractDeepPropertyByParentMapKey(obj, prop);

          if (isUndefined(value) && !isUndefined(props) && Array.isArray(props)) {
            return props.some(parent => {
              const str = String(parent[tail as string]).toLowerCase();

              return strict ? str === term : !!~str.indexOf(term);
            });
          }

          if (isUndefined(value)) {
            return false;
          }

          const strValue: string = String(value).toLowerCase();

          return strict ? term === strValue : !!~strValue.indexOf(term);
        });
      });
    });
  }
}
